// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__rQiry","success":"Toast_success__Cfxyu","error":"Toast_error__Tcr4w","info":"Toast_info__p9Cj9","fade-out":"Toast_fade-out__M9GIT"};